import {
    FilterType,
} from 'app/enums/common.enums'
import {
    FilterConfig,
} from 'app/hooks/useFilter'

import {
    StandardBaseLeaseFilterRequestResponse,
} from 'app/requests/RateCard/RateCard.types'

const filterConfig: FilterConfig<keyof Pick<StandardBaseLeaseFilterRequestResponse,
    'pricingAccountCompanyName'>> = {
        pricingAccountCompanyName: {
            filterField: 'pricingAccountCompanyName',
            filterType: FilterType.Array,
        },
    }

export default filterConfig
